import * as $ from 'jquery';

// Animation trigger when in view
// function isScrolledIntoView(elem: any) {
//     const docViewTop = $(window).scrollTop()!;
// 	const docViewBottom = docViewTop + $(window).height()!;
// 	const elemTop = $(elem).offset()!.top;
// 	const elemBottom = elemTop + $(elem).height()!;
//     return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
// }
// $(window).scroll(function () {
//     $('.animation__wrapper').each(function () {
//         if (isScrolledIntoView(this)) {
//             $(this).addClass('visible');
//         }
//     });
// });


// Animation trigger on Click
window.addEventListener('load', function () {
	const pest_click = document.querySelector('.animation__wrapper');
	if (pest_click) {
		pest_click.addEventListener('click', function () {
			pest_click.classList.add('clicked');
		});
	}
});